import { FieldProps } from 'react-admin';
import { Chip, colors } from '@material-ui/core';

const { grey, green, red } = colors;

type StatusFieldProps = FieldProps & {
  colors?: string[];
  keys?: string[];
  values?: string[];
};

export default function StatusField({
  record,
  source = 'status',
  colors = [grey[500], red[500], green[500]],
  keys=['WAITING', 'CANCELED', 'CONFIRMED'],
  values = ['Aguardando', 'Cancelado', 'Confirmado']
}: StatusFieldProps) {
  const index = keys.findIndex(k => k === record?.[source]);
  if (!record || index === -1) {
    return null;
  }

  return (
    <Chip
      key={record.id}
      label={values[index]}
      style={{
        backgroundColor: colors[index],
        color: '#ffffff'
      }}
    />
  );
}
